export default "__VITE_ASSET__CYZ9quYR__"